import { FC } from 'react';
import { IonToggle } from '@ionic/react';
import { IonToggleCustomEvent, ToggleChangeEventDetail } from '@ionic/core';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    // full width so justify="space-between" pushes the switch to the right;
    // pin the font size so the label doesn't inherit oversized fonts from the host context
    toggle: {
        width: '100%',
        fontSize: 14,
        color: 'var(--ion-color-primary)'
    }
});

export interface ISharedWithViewersToggleProps {
    shared: boolean;
    onChange: (shared: boolean) => void;
    'data-id'?: string;
}

export const SharedWithViewersToggle: FC<ISharedWithViewersToggleProps> = ({
    shared,
    onChange,
    'data-id': dataId
}) => {
    const classes = useStyles();

    return (
        <IonToggle
            className={classes.toggle}
            data-id={dataId}
            data-value={shared}
            checked={shared}
            onIonChange={(e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>) => onChange(e.detail.checked)}
        >
            Shared with Viewers
        </IonToggle>
    );
};
